// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_PRODUCT_SEARCH_QUERY_STRING
});



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/search-query-string.js